import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { getApiBaseUrl } from "@/config/api";
import type { TriageWorklistResponse, TriageWorklistSummaryEntry } from "@/types/triageWorklist";

export const triageKeys = {
  list: () => ["triage-worklists"] as const,
  worklist: (id: string) => ["triage-worklist", id] as const,
};

/** Site triage worklists (internal users only; the endpoint 403s otherwise). */
export function useTriageWorklists(token: string | null, enabled: boolean) {
  return useQuery({
    queryKey: triageKeys.list(),
    queryFn: async () =>
      (
        await axios.get(`${getApiBaseUrl()}/api/triage/worklists`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      ).data as TriageWorklistSummaryEntry[],
    enabled: !!token && enabled,
    staleTime: 5 * 60 * 1000,
  });
}

/** One site worklist: every study, its routing decision, and routed studies' device results. */
export function useTriageWorklist(token: string | null, worklistId: string | undefined) {
  return useQuery({
    queryKey: triageKeys.worklist(worklistId ?? ""),
    queryFn: async () =>
      (
        await axios.get(
          `${getApiBaseUrl()}/api/triage/worklist/${encodeURIComponent(worklistId!)}`,
          { headers: { Authorization: `Bearer ${token}` } },
        )
      ).data as TriageWorklistResponse,
    enabled: !!token && !!worklistId,
    staleTime: 60 * 1000,
  });
}
